import axios from './orderInstance'

const ORDER_API_URL = import.meta.env.VITE_API_URL_ORDER

// Runs a live profanity check on arbitrary text via the store-scoped endpoint.
// This route is NOT company-scoped, so we hit an absolute URL to bypass the
// orderInstance interceptor's /v2/companies/{companyId} prefix. Returns the
// resulting status string (accepted | rejected | requires_manual_check) or null.
const checkProfanityText = async (text: string, storeName: string): Promise<string | null> => {
  const response = await axios.get(`${ORDER_API_URL}/v1/profanity-check/types/text`, {
    params: { text, store_name: storeName },
  })
  return response.data?.status ?? null
}

export default checkProfanityText
